// extracted by mini-css-extract-plugin
export default {"tr":"propertytable_tr__SXhqQ","hiddenDisplay":"propertytable_hiddenDisplay__9De52"};